import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  makeStyles
} from '@material-ui/core';
import {
  MoreVert as MoreIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Archive as ArchiveIcon,
  Restore as UnarchiveIcon,
  Room as PinIcon,
  VolumeOff as MuteIcon,
  VolumeUp as UnmuteIcon
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    opacity: 0.7,
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 1,
      backgroundColor: theme.palette.action.hover,
    }
  },
  deleteMenuItem: {
    color: theme.palette.error.main,
    '& .MuiListItemIcon-root': {
      color: theme.palette.error.main,
    }
  }
}));

const ChatQuickActions = ({ 
  chat, 
  currentUserId,
  onEdit,
  onDelete,
  onPin,
  onMute,
  onArchive
}) => {  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const chatUser = chat?.users?.find(u => u.userId === currentUserId);
  const isPinned = chatUser?.isPinned || false;
  const isMuted = chatUser?.isMuted || false;
  const isArchived = chatUser?.isArchived || false;

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };  const handleAction = (action) => {
    handleMenuClose();
    
    switch (action) {
      case 'edit':
        if (onEdit) onEdit(chat);
        break;
      case 'delete':
        if (onDelete) onDelete(chat);
        break;
      case 'pin':
        if (onPin) onPin(chat);
        break;
      case 'mute':
        // ✅ Silenciar/dessilenciar imediatamente sem modal
        if (isMuted) {
          if (onMute) onMute(chat, null); // Desmutar
        } else {
          // ✅ Silenciar por 8 horas por padrão
          if (onMute) onMute(chat, 480); // 480 minutos = 8 horas
        }
        break;
      case 'archive':
        if (onArchive) onArchive(chat);
        break;
      default:        break;
    }
  };

  return (
    <>
      <Tooltip title="Mais opções">
        <IconButton
          className={classes.menuButton}
          onClick={handleMenuClick}
          size="small"
        >
          <MoreIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: { minWidth: 180 }
        }}      >
        {chat?.type === 'group' && (
          <MenuItem onClick={() => handleAction('edit')}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Editar" />
          </MenuItem>
        )}
        
        <MenuItem onClick={() => handleAction('pin')}>
          <ListItemIcon>
            <PinIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={isPinned ? "Desfixar" : "Fixar"} />
        </MenuItem>
        
        <MenuItem onClick={() => handleAction('mute')}>
          <ListItemIcon>
            {isMuted ? <UnmuteIcon fontSize="small" /> : <MuteIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText primary={isMuted ? "Dessilenciar" : "Silenciar"} />
        </MenuItem>
        
        <MenuItem onClick={() => handleAction('archive')}>
          <ListItemIcon>
            {isArchived ? <UnarchiveIcon fontSize="small" /> : <ArchiveIcon fontSize="small" />}
          </ListItemIcon>          <ListItemText primary={isArchived ? "Desarquivar" : "Arquivar"} />
        </MenuItem>
        
        <MenuItem onClick={() => handleAction('delete')} className={classes.deleteMenuItem}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>          <ListItemText primary="Excluir" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ChatQuickActions;
